import { Icon } from '@winnin/winnin_ui.components.icon'

import { useTranslate } from 'lib/tolgee'

import { translations } from './niche-description.i18n'
import type { INicheDescription } from './niche-description.types'
import './niche-description.styles.scss'

export const NicheDescriptionView = ({ descriptionText, isLoading }: INicheDescription) => {
  const t = useTranslate()

  return (
    <div className="NicheDescription">
      <Icon icon="sparkle" height="24px" width="24px" fill="#9927F0" />
      <span>{isLoading ? t(translations.thinkingText) : descriptionText}</span>
    </div>
  )
}
